<template>
    <form @submit.prevent="submit">
        <div class="form-group">
            <label for="fullname">Name</label>
            <input id="fullname" v-model="enquiry.name" type="text" class="form-control form-control-lg" :disabled="loading" placeholder="Your name" required>
        </div>
        <div class="form-group">
            <label for="email">Email</label>
            <input id="email" v-model="enquiry.email" type="email" class="form-control form-control-lg" :disabled="loading" placeholder="Your email" required>
        </div>
        <div class="form-group">
            <label for="message">Message</label>
            <textarea id="message" v-model="enquiry.message" class="form-control form-control-lg" rows="5" placeholder="How can we help?" :disabled="loading" required></textarea>
        </div>
        <btn type="submit" primary rounded class="btn-submit" :disabled="loading">Send</btn>
    </form>
</template>

<script>
import InsertEnquiry from '@/graphql/InsertEnquiry.gql';
import Btn from '@/components/global/Btn';

export default {
    name: 'contact-form',

    components: {
        Btn,
    },

    data() {
        return {
            enquiry: {},
            loading: false,
        };
    },

    methods: {
        async submit() {
            this.loading = true;
            this.$apollo.mutate({
                mutation: InsertEnquiry,
                variables: {
                    ...this.enquiry,
                },
            }).then(() => {
                alert('Thank you for your interest. Our team will contact you soon.');
                this.loading = false;
                this.enquiry = {};
            });
        },
    },
};
</script>

<style lang="scss" scoped>
form {
    max-width: 700px;
    background-color: rgba(248, 248, 248, 0.71);
    margin: 0 auto;

    label {
        color: #000112;
    }

    .form-control {
        background-color: #ffffff;
        font-size: 14px;

        &::placeholder {
            color: #B5C0C7;
        }

        @include media-breakpoint-up(md) {
            margin-bottom: 24px;
        }
    }
    input.form-control {
        height: 50px;
        border-radius: 3px;
    }

    button.btn-submit {
        margin: 40px auto 0;
        display: block;
        min-width: 168px;
        height: 51px;
    }
}
</style>
